import type { FlowId } from '../../types';
import { normalizeFlowId } from '../flowRegistry';

interface FlowSources {
  routeFlow?: string | null;
  queryFlow?: string | null;
  pathFlow?: string | null;
  fallback: FlowId;
}

export const resolveFlowIdFromSources = ({ routeFlow, queryFlow, pathFlow, fallback }: FlowSources): FlowId => {
  return normalizeFlowId(routeFlow ?? queryFlow ?? pathFlow ?? fallback);
};
